import { useContext } from 'react'
import { VideoDataContext } from '../contexts'

export const useVideoDataContext = () => useContext(VideoDataContext)
